import { Form, InputGroup } from 'react-bootstrap'
import React, { memo } from 'react'

import PropTypes from 'prop-types'
import { XStack } from '../../index.style'
import { useField } from 'formik'

const DateTimeField = ({ label, format, disabled = false, min, ...props }) => {
  const [field, meta] = useField(props.name)

  return (
    <Form.Group controlId={`validationFormik${field.name}`} style={{ minHeight: 128, width: 256 }}>
      <XStack>
        <Form.Label as={'b'}>{label}</Form.Label>
      </XStack>
      <InputGroup hasValidation>
        <Form.Control
          type="datetime-local"
          {...field}
          {...props}
          disabled={disabled}
          isInvalid={meta.error && meta.touched}
          style={{ borderRadius: 16, color: 'black', backgroundColor: disabled ? '#f5f5f5' : 'white' }}
          value={field.value ? field.value : ''}
        />
        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  )
}

export default memo(DateTimeField)

DateTimeField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  disabled: PropTypes.bool,
}
